import type { Fetch } from '$lib/api/rpc';

// WebRPC binds fetch to a class (this.fetch = fetch), reassigning its context.
// When using the browsers fetch method, the method expect to have access to the window context.
// This wraps the fetch in a function, so the fetch method will not loose its context

export const fetchWrapper = (fetch: Fetch) => (info: RequestInfo, init?: RequestInit) =>
	fetch(info, init);
